module.exports = __webpack_public_path__ + "static/media/home_image.2f0bf34b.png";